import React from "react"
import {Card, CardBody, Col, Container, Row} from "reactstrap";
import {useHistory, useParams} from "react-router-dom";
import ErrorHandler from "../../shared/components/ErrorHandler";
import ContentCardHeader from "../../shared/components/card/accessories/ContentCardHeader";
import ContentCardFooter from "../../shared/components/card/accessories/ContentCardFooter";
import {useCurrentUserQuery} from "../../queries/CurrentUser";
import paths from "../../config/paths";
import DownloadReport from "../../shared/components/card/DownloadReport";
import TargetVictimCard from "../../shared/components/card/TargetVictimCard";
import SectorCard from "../../shared/components/card/withIcon/SectorCard";
import ActorsCard from "../../shared/components/card/ActorsCard";
import ReferencesRow from "../../shared/components/card/accessories/ReferencesRow";
import PurchaseContent from "../../shared/components/card/PurchaseContent";
import Page from "../../shared/components/Page";
import {PLATFORM_FEATURE_CONTENTS} from "../../shared/helpers/features";
import LoadingSpinnerPage from "../../shared/components/LoadingSpinnerPage";
import InfoRow from "../../shared/components/card/accessories/InfoRow";
import {useActivityDetailsQuery} from "../../queries/Activities";
import ScreenshotBase64Card from "../../shared/components/card/ScreenshotBase64Card";
import TargetOrganizationsCard from "../../shared/components/card/TargetOrganizationsCard";
import ActivityEditsBar from "../../shared/components/card/accessories/ActivityEditsBar";
import {canUserEditContent} from "../../shared/helpers/permissions";


const ActivityDetail = () => {
  const { uid: uid } = useParams();
  const { data, isIdle, isLoading, isError, error } = useActivityDetailsQuery(uid);
  const { data: dataCurrentUser, isIdle: isIdleCurrentUser, isLoading: isLoadingCurrentUser } = useCurrentUserQuery();
  const history = useHistory();

  const updateFilters = (field, value) => {
    const urlParams = new URLSearchParams();
    urlParams.set(field, value);
    history.push(`${paths.contentsPath}?${urlParams.toString()}`);
  }

  const onCountryClick = (data) => {
    history.push(`${paths.contentsPath}?targeted_countries=${data.target.dataItem.dataContext.id}`)
  }
  if (isError) {
    return <ErrorHandler error={error} />
  }

  if (isLoading || isIdle || isIdleCurrentUser || isLoadingCurrentUser) {
    return <LoadingSpinnerPage feature={PLATFORM_FEATURE_CONTENTS} />
  }

  const info = data.data;
  const tlp = info.tlp.tlp;
  const isEditable = canUserEditContent(dataCurrentUser?.data, info);

  return (
    <Page
      feature={PLATFORM_FEATURE_CONTENTS}
    >
      <Container>
        <Row>
          <Col lg={12} md={12}>
            <Card className={'h-auto'}>
              <CardBody>
                <ContentCardHeader
                  created_dt={info.created_dt}
                  confidence={info.confidence}
                  tlp={tlp}
                  updateFilters={(type,val) => updateFilters({type :type,name:val})}
                  title={`${info.category}: ${info.title}`}
                />
                <pre className={'mb-3 pre--text'}>{info.text}</pre>
                {!!info.network && <InfoRow  title="NETWORK" value={info.network}/>}
                {info.references?.length > 0 && <ReferencesRow references={info.references}/>}
                <ContentCardFooter tags={info.tags} tlp={tlp} />
                {
                  isEditable &&
                    <div style={{position: 'absolute', bottom: '40px', right: '10px'}}>
                      <ActivityEditsBar activity={info} />
                    </div>
                }
              </CardBody>
            </Card>
          </Col>
          <Col lg={6} md={6} className={'d-flex flex-column'} style={{paddingBottom: '30px'}}>
            <ActorsCard actors={info.actors} />
          </Col>
          <Col lg={6}>
            <PurchaseContent info={info} org={dataCurrentUser?.data?.organization} />
            <DownloadReport info={info} />
            <SectorCard updateFilters={(val)=> { updateFilters('targeted_sectors', val) }}  sectors={info.sectors} />
            {
              !!info.targeted_organizations?.length > 0 &&
              <TargetOrganizationsCard targetedOrganizations={info.targeted_organizations} />
            }
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TargetVictimCard updateFilters={updateFilters} onCountryClick={onCountryClick} targetedCountries={info.targeted_countries} />
          </Col>
        </Row>
        {
          !!info.screenshot &&
          <Row>
            <Col md={12}>
              <ScreenshotBase64Card
                  base64={info.screenshot}
                  alt={`${info.title} screenshot`}
              />
            </Col>
          </Row>
        }
      </Container>
    </Page>
  )
}

export default ActivityDetail;
